export default __webpack_public_path__ + "static/media/sentimentanalisis.5264adc3.jpg";